import styles from './CustomTag.module.scss';

type CustomTagProps = {
  content?: string;
};

export const CustomTag: React.FC<CustomTagProps> = ({
  content,
}): JSX.Element => {
  if (!content) {
    return <></>;
  }

  const greenTags = [
    'assigned',
    'active',
    'checkout',
    'completed',
    'accountant',
  ];
  const blueTags = ['dispatcher', 'driver'];
  const lowercaseContent = content.toLowerCase();
  let relevantStyle;

  if (greenTags.includes(lowercaseContent)) {
    relevantStyle = styles.tag_green;
  } else if (blueTags.includes(lowercaseContent)) {
    relevantStyle = styles.tag_blue;
  } else {
    relevantStyle = styles.tag_red;
  }

  return <span className={`${styles.tag} ${relevantStyle}`}>
    {content}
  </span>;
};
